export default __webpack_public_path__ + "static/media/6-1.3cbe1289.svg";